export default String.raw`
.geowidget-container .easypack-widget{
	&, &.mobile{
		.map-list-row .map-list-flex {
			height: 400px;
		}
	}
}

.easypack-widget{
	width: calc(100% - 30px);
	margin: 5px 0 40px;
	border: 1px solid $lightBorderColor;
	font-family: $fontFamily, sans-serif;
	.input-group-btn{
		width: 60px;
	}
	.search-widget{
		.input-group{
			background: $optionsSectionBg;
			padding: 0;
			border-bottom: 1px solid $lightBorderColor;
			width: 100%;
		}
		.btn{ 
			border-left: none;
			position: absolute;
			font-size: 20px;
			padding: 12px 15px;
			border: none;
			color: $iconColors;
			background: $bgColor;
			top: 0;
			font-style: normal;
			font-weight: normal;
			font-variant: normal;
			text-transform: none;
			line-height: 1;
			-webkit-font-smoothing: antialiased;
			transition: all ease 300ms;
			&:before{
				content:'\e610';
			}
			&:hover{
				background: $btnSolidHoverBgColor !important;
				color: $btnSolidHoverTextColor;
			}
		}
		.form-control{
			font-family: $fontFamily, sans-serif;
			font-size: 16px;
			font-weight: 400;
		}
	}
	.map-list-row .map-list-flex{
		.list-widget{
			background: $bgColor;
			.list-wrapper{
				width: calc(100% + 3px);
				ul li a{
					&:hover, &.active{
						background-color: $btnSolidHoverBgColor;
						.title, .address{
							color: $btnSolidHoverTextColor;
						}
					}
				}
			}
		}
		.map-widget .info-window{
			font-family: $fontFamily, sans-serif;
			.links .select-link{
				display: none;
			}
		}
	}
}

.geowidget-container .message-bar-ui{
	width: calc(100% - 30px);
}

.geowidget-container .collection-points-box{
	position: relative;
	margin-bottom: 40px;
	.collection-point-search-input{
		width: calc(100% - 30px);
		height: 60px;
	}
	.ti-search{
		font-size: 20px;
		padding: 20px;
		position: absolute;
		top: 0;
		right: 30px;
		z-index: 1;
		color: $iconColors;
		cursor: pointer;
		transition: all ease 300ms;
		&:hover{
			color: $btnSolidHoverTextColor;
			background: $btnSolidHoverBgColor;
		}
	}
}

.poo-ui{
	width: calc(100% - 30px);
	.half-ui-with-space-ui{
		&.f-left-ui{
			width: 50%;
		}
		&.f-right-ui{
			margin-right: 0;
		}
	}
}

.cart-collection-point{
	.mCS_no_scrollbar{
		width: calc(100% - 30px);
	}
	.mCSB_scrollTools{
		right: 21px;
		.mCSB_dragger .mCSB_dragger_bar{
			background-color: $primaryColor !important;
		}
	}
}

.maps-container-js.message-popup-background .close-ui {
    padding: 10px;
    z-index: 9999;
	display: block;
}

@media only screen and (min-width: 868px) {
	.maps-container-js.message-popup-background .close-ui {
		display: none;
	}
}
@media only screen and (max-width: 1279px) {
	.geowidget-container, .poo-ui{
		margin-top: 20px;
		color: $labelsColor;
		font-size: 12px;
		width: 100%;
	}
	.easypack-widget{
		margin: 0;
		width: 100%;
		&.mobile .search-widget{
			.input-group{
				padding: 0;
			}
			.form-control{
				font-size: 12px;
			}
		}
		.input-group-btn{
			width: 50px;
		}
	}
	.poo-ui{
		.mb10-ui{
			margin-bottom: 0;
		}
		.flex-ui{
			display: block;
		}
		.half-ui-with-space-ui.f-left-ui{
			width: 100%;
			margin-bottom: 0;
		}
		.cart-collection-point .mCS_no_scrollbar{
			width: 100%;
		}
	}
}
`